export default "__VITE_ASSET__B3OPun10__"